import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    ctaBox: {
        maxWidth: 580,
        margin: "125px auto 125px auto",
        textAlign: "center",
        padding: '25px 10px 15px 10px',
        backgroundColor: '#0b1728',
        borderRadius: 8,
        [theme.breakpoints.down('xs')]: {
            margin: "50px auto 50px auto",
            width: "100%",
            maxWidth: 380,
        },
    },
    ctaText: {
        marginBottom: theme.spacing(2),
        fontWeight: 600,
        fontSize: "1.3em",
        color: "#fff",
        [theme.breakpoints.down('xs')]: {
            fontSize: "1.2em",
        },
    },
    ctaImage: {
        width: 100, 
        height: 100,
        display: 'block',
    },
    ctaButton: {
        fontSize: ".7em",
        padding: "8px 20px",
        borderRadius: 5,
        color: '#ffffff',
        height: 40,
        backgroundColor: '#f53a3a',
        '&:hover': {
            boxShadow: 'unset',
            border: 0,
        },
        [theme.breakpoints.down('xs')]: {
            fontSize: ".7em",
        },
    },
}));

export default useStyles;


